import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";

export default function PublicRoute({ children }) {
    const { user, token, loading } = useSelector((state) => state.user);
    const location = useLocation();

    // If there's a token and we are still loading user details, show a spinner
    if (token && loading) {
        return (
            <div
                className="d-flex justify-content-center align-items-center vh-100"
                style={{ backgroundColor: "#000", color: "#fff" }}
            >
                <Spinner animation="border" variant="warning" size="lg" />
            </div>
        );
    }

    // If user is logged in, redirect away from public-only pages (like login)
    if (user && token) {
        // Redirect to home or the page they came from
        const from = location.state?.from || "/";
        return <Navigate to={from} replace />;
    }

    // If not logged in, allow access to the public page
    return children;
}
